module.exports = __webpack_public_path__ + "static/media/S5_Marketing_Research.9c40b626.svg";